module.exports = __webpack_public_path__ + "img/reply_close.b0df2fc8.png";